import { useGetDeviceType } from "_common/hooks/global";
import BroadcasterTitle     from "_components/atoms/broadcastTitle";
import CardWrapper          from "_components/atoms/cardWrapper";
import Divider              from "_components/atoms/divider";
import BroadcastChips       from "_components/molecules/broadcastChips";
import BroadcasterHeader    from "_components/molecules/broadcasterHeader";

import ActionButtons from "../actionButtons";

import Ads       from "./ads";
import Media     from "./media";
import useStyles from "./styles";

const component = props => {
	const {
		onVideoEnd,
		videoType,
		videoSrc,
		videoItem,
		onClickLike,
		isVideoLike,
		toggleCollapse,
		isVideoEnded,
		nextVideoItem,
		timeLeft,
		cancelClickHandler,
		playNowClickHandler,
		thumbnail,
		startTime,
		feedId,
		adTagURL,
		onClickCommentIcon
	} = props;

	const {
		actorDetails,
		title,
		commentCount,
		views,
		reactions,
		createdAt,
		tags,
		locale,
		id,
		game
	} = videoItem;

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const likeCount   = reactions?.find ( item => item?.reaction === "AGREE" )?.count || 0;
	const deviceType  = useGetDeviceType ();
	const isDesktop   = deviceType === "desktop";

	return (
		<>

			<Media
				adTagURL = { adTagURL }
				cancelClickHandler = { cancelClickHandler }
				isVideoEnded = { isVideoEnded }
				nextVideoItem = { nextVideoItem }
				onVideoEnd = { onVideoEnd }
				playNowClickHandler = { playNowClickHandler }
				startTime = { startTime }
				thumbnail = { thumbnail }
				timeLeft = { timeLeft }
				videoSrc = { videoSrc }
				videoType = { videoType }
			/>

			<CardWrapper
				noBackground
				customStyles = { "" }
				type = { "secondary" }
			>

				<div className = { classes.feedInfoContaier }>

					<Ads />

					<BroadcasterTitle
						endTimeUTC = { createdAt }
						sessionData = { title }
						views = { views }
					/>

					<BroadcastChips
						isFromVideos
						game = { game }
						isVideoLike = { isVideoLike }
						localeKey = { locale }
						onClickLike = { onClickLike }
						sessionDataId = { id }
						tags = { tags }
						title = { title }
						toggleCollapse = { toggleCollapse }
						totalComments = { commentCount }
						totalLikes = { reactions[0]?.count }
					/>

					{!isDesktop ? (
						<ActionButtons
							commentCount = { commentCount }
							feedId = { feedId }
							isVideoLike = { isVideoLike }
							likeCount = { likeCount }
							onClickCommentIcon = { onClickCommentIcon }
							onClickLike = { onClickLike }
						/>
					) : null}

				</div>

				<Divider />

				<BroadcasterHeader
					followersCount = { actorDetails?.followerCount }
					id = { actorDetails?.id }
					isCeleb = { actorDetails?.isCeleb }
					isFollowingUser = { actorDetails?.isFollowing }
					name = { actorDetails?.name }
					photo = { actorDetails?.photo }
					videoId = { id }
					videoTitle = { title }
				/>

				<Divider />

			</CardWrapper>
		</>
	);
};

export default component;
